import Modal from './Modal';
export { ModalVariants, ModalSize } from './constants';
export * from './Modal';
export default Modal;
